var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3679 2.63216C11.8583 -0.877386 6.14604 -0.877386 2.6365 2.63216C0.936467 4.33286 0 6.59354 0 8.99783C0 11.4021 0.936467 13.6628 2.6365 15.3628C4.39162 17.118 6.69691 17.9951 9.00217 17.9951C11.3074 17.9951 13.6127 17.118 15.3678 15.3628C18.8774 11.8533 18.8774 6.14237 15.3679 2.63216ZM14.3819 14.3768C11.4155 17.3432 6.58881 17.3432 3.62247 14.3768C2.18604 12.9404 1.39459 11.0298 1.39459 8.99783C1.39459 6.96588 2.18604 5.05526 3.62247 3.61813C6.58881 0.651786 11.4155 0.652489 14.3819 3.61813C17.3475 6.58447 17.3475 11.4112 14.3819 14.3768Z",
    fill: "#EC3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0068 10.9254L10.0327 8.95409L12.0068 6.98283C12.2787 6.71089 12.2787 6.2695 12.0075 5.99682C11.7349 5.72348 11.2935 5.72418 11.0208 5.99612L9.04538 7.96879L7.06993 5.99612C6.79729 5.72418 6.3559 5.72348 6.08326 5.99682C5.81132 6.26946 5.81132 6.71085 6.08396 6.98283L8.05804 8.95409L6.08396 10.9254C5.81132 11.1973 5.81132 11.6387 6.08326 11.9114C6.21925 12.048 6.39844 12.1157 6.57696 12.1157C6.75549 12.1157 6.93398 12.0473 7.06996 11.912L9.04541 9.93936L11.0209 11.912C11.1569 12.048 11.3353 12.1157 11.5139 12.1157C11.6924 12.1157 11.8716 12.0473 12.0076 11.9114C12.2794 11.6387 12.2794 11.1973 12.0068 10.9254Z",
    fill: "#EC3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.21add9a52351e67acc585c569ed79f3b.svg";
export { ForwardRef as ReactComponent };